export default {
    formId: 'editarTerminalForm', //'checkoutForm',
    formField: {
      name: {
        name: 'name',
        label: 'Nombre area*',
        requiredErrorMsg: 'El nombre area es requerido.'
      },
      description: {
        name: 'description',
        label: 'Descripcion*',
        requiredErrorMsg: 'La descripcion es requerida.'
      },
      typeTerminal: {
        name: 'typeTerminal',
        label: 'Tipo terminal',
        requiredErrorMsg: 'El tipo de terminal es requerida.'
      },
    }
};
  